import React, { useState, useEffect, useCallback } from 'react';
import {
  Card,
  Table,
  message,
  Empty,
  Spin
} from 'antd';
import { membershipService } from '../../../services';
import { MembershipGetEventResponseItem, EventsTabProps } from "../../../model";

const EventsTab: React.FC<EventsTabProps> = ({
  membershipId
}) => {
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState<MembershipGetEventResponseItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  // Load event data when the tab is displayed
  const fetchEventData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await membershipService.getEvents(membershipId);
      if (data && Array.isArray(data)) {
        setEventData(data);
      } else {
        setEventData([]);
        message.info('沒有找到活動參與資料');
      }
    } catch (error) {
      console.error('Failed to fetch event data:', error);
      setError('載入活動參與資料時發生錯誤');
      message.error('載入活動參與資料時發生錯誤');
      setEventData([]);
    } finally {
      setLoading(false);
    }
  }, [membershipId]);

  useEffect(() => {
    fetchEventData();
  }, [fetchEventData]);

  // Define table columns (removed action column)
  const columns = [
    {
      title: '活動名稱',
      dataIndex: 'eventName',
      key: 'eventName',
    },
    {
      title: '開始日期',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: '結束日期',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: '備註',
      dataIndex: 'remarks',
      key: 'remarks',
      render: (text: string) => text || '-',
    }
  ];

  // Render table or empty state
  const renderTable = () => {
    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
          <Spin tip="載入中..." />
        </div>
      );
    }

    if (error) {
      return (
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE} 
          description={error}
        />
      );
    }

    if (eventData.length === 0) {
      return (
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE} 
          description="尚無活動參與資料" 
        />
      );
    }
    
    return (
      <Table
        sticky
        rowKey={(record, index) => `${record.eventName}-${index}`}
        columns={columns}
        dataSource={eventData}
        pagination={false}
      />
    );
  };

  return (
    <Card>
      {renderTable()}
    </Card>
  );
};

export default EventsTab;
